
import React, { useState, useEffect, useContext } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import tmdbApi from "../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import { useNavigate } from "react-router-dom";
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import axios from 'axios';
import { keyActivate } from "../utils/a11y";
import BankConnectBanner from "./dashboard/BankConnectBanner";

let { lambda, country, appname } = window.app;


const Profile = () => {
    const navigate = useNavigate();
    const [countries, setCountries] = useState('');
    const [idc, setIdc] = useState('');

    const [image, setImg] = useState('');
    const [userName, setUserName] = useState([]);
    const [phonenumber, setPhoneNumber] = useState("");

    const [success, setSuccess] = useState(false);
    const [phoneerror, setPhoneError] = useState('');
    const [nameerror, setNameError] = useState('');
    // const [formData, setFormData] = useState({});
    const [name, setName] = useState('');
    const [email, setEmail] = useState("");
    const [data, setData] = useState([])
    const [passwordInput, setPasswordInput] = useState({
        password: '',
        confirmPassword: ''
    })

    const [IdcError, setIdcError] = useState('');
    const [popup, setShowPopup] = useState('');

    const [passwordError, setPasswordErr] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [passwordShown, setPasswordShown] = useState(false);
    const [number, setNumber] = useState(false);
    const [upper, setUpper] = useState(false);
    const [limit, setLimit] = useState(false);
    const [lower, setLower] = useState(false);
    const [special, setSpecial] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [defaultCountryCode, setDefaultCountryCode] = useState("");
    const [error, setError] = useState('');
    const [oldPasswordError, setOldPasswordError] = useState("");
    const [loaderEnable, setLoaderEnable] = useState("");
    const [filesData, setFilesData] = useState([]);

    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [files, setFiles] = useState([]);
    const { welcomeMsg, setWelcomeMsg, GetClientDataContext, isRefreshed, setIsRefreshed, businessData, clientInfo, setBusinessData, uploadLogo, userData, setActiveMenuId, initialProfileData, setInitialProfileData, isUpdated, setIsUpdated, setUserData, profileData, setProfileData, setUploadLogo } = useContext(contentContext)
    let siteConfig = window?.site?.common;
    let appResourcesUrl = siteConfig?.imageCloudfront;
const [toastType, setToastType] = useState(""); // Add this with other useState declarations
    // Add this new state at the top with other useState declarations
    // Contact Form States (add with other useState declarations)
    // Contact Form States (add with other useState declarations)
    const [contactFormData, setContactFormData] = useState({
        name: '',
        email: '',
        phone: '',
        issueType: '',
        subject: '',
        message: ''
    });

    const [contactFormErrors, setContactFormErrors] = useState({});
    const [isSubmittingContact, setIsSubmittingContact] = useState(false);
    // Add this useEffect to auto-populate contact form when it opens
    // Auto-populate contact form with INITIAL user data ONCE (add with other useEffects)
    useEffect(() => {
        if (userData && profileData && !contactFormData.name) {
            // Only populate if contactFormData is empty (first time)
            setContactFormData({
                name: userData?.contactname || '',
                email: userData?.emailId || '',
                phone: profileData?.phone || '',
                subject: '',
                message: ''
            });
        }
    }, [userData, profileData]);
    // Auto-populate contact form with user data on mount only
    useEffect(() => {
        // Only populate once when component mounts
        if (userData && profileData) {
            setContactFormData(prev => {
                // Only set if not already set
                if (!prev.name && !prev.email && !prev.phone) {
                    return {
                        name: userData?.contactname || '',
                        email: userData?.emailId || '',
                        phone: profileData?.phone || '',
                        subject: '',
                        message: ''
                    };
                }
                return prev;
            });
        }
    }, []); // Empty dependency array - runs only once on mount

    // Separate useEffect to capture initial values when userData/profileData loads
    useEffect(() => {
        if (userData && profileData) {
            setContactFormData(prev => {
                // Only update if values are empty (initial load)
                if (!prev.name || !prev.email) {
                    return {
                        ...prev,
                        name: userData?.contactname || '',
                        email: userData?.emailId || '',
                        phone: profileData?.phone || ''
                    };
                }
                return prev;
            });
        }
    }, [userData?.contactname, profileData?.phone, userData?.emailId]); // Only watch these specific values once
    // Remove contactFormData from dependency to prevent updatesthese handler functions
    const handleContactFormSubmit = async (e) => {
        e.preventDefault();

        const errors = validateContactForm();
        if (Object.keys(errors).length > 0) {
            setContactFormErrors(errors);
            return;
        }

        setIsSubmittingContact(true);
        setLoaderEnable("contactForm");

        try {
            const response = await axios({
                method: "POST",
                url: `${lambda}/sendSupportEmail?appname=${appname}`,
                headers: {
                    'accept': 'application/json, text/plain, */*',
                    'content-type': 'application/json',
                },
                data: {
                    issueType: contactFormData.issueType,
                    subject: contactFormData.subject,
                    message: contactFormData.message,
                    userName: userData?.contactname,
                    userEmail: userData?.emailId
                }
            });

            if (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);
                    return;
                }

                // Show success message
                setToastMessage("Message sent successfully!");
                setToastType("success");

                // Reset form fields
                setContactFormData(prev => ({
                    ...prev,
                    issueType: '',
                    subject: '',
                    message: ''
                }));
                setContactFormErrors({});
            }

        } catch (error) {
            console.error("Contact form error:", error);
            setToastMessage("Failed to send message. Please try again.");
            setToastType("error");
        } finally {
            setIsSubmittingContact(false);
            setLoaderEnable("");
        }
    };
    const handleContactFormChange = (e) => {
        const { name, value } = e.target;
        setContactFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field
        if (contactFormErrors[name]) {
            setContactFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateContactForm = () => {
        const errors = {};

        if (!contactFormData.issueType) {
            errors.issueType = 'Please select an issue type';
        }

        if (!contactFormData.subject.trim()) {
            errors.subject = 'Subject is required';
        }

        if (!contactFormData.message.trim()) {
            errors.message = 'Message is required';
        } else if (contactFormData.message.trim().length < 10) {
            errors.message = 'Message must be at least 10 characters';
        }

        return errors;
    };



    useEffect(() => {
        // if (!localStorage.getItem("token")) {
        //     navigate("/");
        // }
        // GetUserData();
        GetCountries();
        userActivity();
        // GetCountries();
    }, []);


    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/signin");
            return;
        }

        // Skip if clientInfo is still empty
        if (!clientInfo?.subscriptionPayment) return;

        if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
            navigate("/signin");
        }
    }, [clientInfo, navigate]);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);
    useEffect(() => {
        // userName = localStorage.getItem("ClientName")?.split(" ");

        setUserName(userData?.contactname?.split(" "));

        setActiveMenuId("")


    }, [userData]);

    useEffect(() => {
        const trimData = (data) =>
            JSON.stringify(
                Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value?.trim?.() ?? value]))
            );

        const isChanged = trimData(profileData) !== trimData(initialProfileData);
        setIsUpdated(isChanged);
        console.log("ischangedddddddddddddddddddddddddddddddddd", isChanged);
    }, [profileData]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        let presentTime = moment();
        let payload;

        payload = {
            "clientid": localStorage.getItem("clientid"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }



    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });
            setCountries(response?.result.data);

        } catch {
            console.log("error");
        }
    };
    console.log("data", data);
    const checkInput = (e) => {
        const onlyDigits = e.target.value.replace(/\D/g, "");
        setPhoneNumber(onlyDigits);

    };

    const handleBack = (e) => {
        // navigate("/usermanagement");
        navigate(-1)
    }
    const handleClose = () => {
        setShowPopup(false)
    }
    const handleUserUpdate = (e) => {
        let flag = true;
        // if (phonenumber === "") {
        //     setPhoneError("Please enter phone number");
        //     flag = false
        //     setTimeout(function () { setPhoneError("") }, 3000);
        // }
        if (profileData?.contactname === "") {
            setNameError("Please enter name");
            flag = false
            setTimeout(function () { setNameError("") }, 3000);
        }

        if (profileData?.phone === "") {
            setPhoneError("Enter phone number");
            setTimeout(function () { setPhoneError("") }, 3000);
            flag = false
        } else if (
            (profileData.idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(profileData.phone)) ||
            (profileData.idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(profileData.phone))
        ) {
            setPhoneError("Invalid phone number format");
            setTimeout(function () { setPhoneError("") }, 3000);
            flag = false


        }

        if (flag) {
            UpdateForm()

        }

    }

    const UpdateForm = async () => {

        setLoaderEnable("updateForm")
        try {

            let response;



            response = await tmdbApi.ClientUserUpdateApi({
                "contactname": profileData?.contactname?.trim(),
                "phone": profileData?.phone?.trim(),

                "idc": profileData?.idc
            });

            if (response?.statusCode === 200) {
                if (response?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setToastMessage("Updated successfully")

                    // GetUserData();
                    GetClientDataContext()
                    setLoaderEnable("")
                }
            }
        } catch {
            console.log("error");
        }
    };

    function onConfirm() {
        setSuccess(false)
    };

    const handlePwdGenerate = (e) => {

        if (passwordInput?.password === "") {
            setError("Please Enter Password");
            setTimeout(function () { setError("") }, 3000);

        } else if (passwordInput?.confirmPassword === "") {
            setError("Please Enter Confirm Password");
            setTimeout(function () { setError("") }, 3000);

        } else if (passwordInput?.oldPassword === "") {
            setError("Please Enter Old Password");
            setTimeout(function () { setError("") }, 3000);

        }
        else if (passwordInput?.confirmPassword !== passwordInput?.password) {
            setConfirmPasswordError("Confirm password is not matched");
            setTimeout(function () { setConfirmPasswordError("") }, 3000);
        }

        else if (!limit || !upper || !special || !lower || !number) {
            console.log('adsfadsf')
            setError("Please enter the password as per the instructions");
            // setTimeout(function () { setError("") }, 3000);

        }
        else if (limit && upper && special && lower && number && confirmPasswordError === "") {
            setError("")
            if (passwordInput?.password === passwordInput?.confirmPassword) {
                setConfirmPasswordError("")
                pwdGenerate();
            }
        }

    }
    console.log('limit', limit)
    console.log('upper', upper)
    console.log('special', special)
    console.log('lower', lower)
    console.log('number', number)
    const pwdGenerate = async () => {
        let response;
        setLoaderEnable("pwdGenerate")
        try {
            response = await tmdbApi.pwdGenerate({
                "emailId": profileData?.emailId,
                "password": passwordInput?.password,
                "oldPassword": passwordInput?.oldPassword
            });


            console.log(response);


            if (response?.statusCode === 200) {


                if (response?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else if (response?.result === "old password is wrong") {
                    setOldPasswordError("old password is incorrect");
                    setLoaderEnable("")
                } else {
                    // setSuccess(true);
                    setToastMessage("Updated successfully");
                    setPasswordInput({ ...passwordInput, password: '', confirmPassword: '', oldPassword: '' })
                    setLoaderEnable("")
                }

            }


        } catch {
            console.log("error");
        }
    };

    const handlePasswordChange = (evnt) => {
        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        const NewPasswordInput = { ...passwordInput, [passwordInputFieldName]: passwordInputValue }
        setPasswordInput(NewPasswordInput);

    }
    const togglePassword = (e) => {
        setPasswordShown(!passwordShown);
    };

    console.log("Datatttttttttttaaaa", data)
    const handleRemove = () => {
        // setUploadImg("")
        //setFormData("")
        setFilesData([])
        setData(prev => ({
            ...prev,
            logo: [] // Clear the logo array
        }));
    }
    const handleUpgrade = () => {
        navigate("/upgradeplan")
    }
    const handleCancelSub = () => {
        setShowPopup(true)
    }
    const handleCancelling = async () => {
        setLoaderEnable("cancel");
        const token = localStorage.getItem("token");

        try {
            const response = await axios({
                method: "POST",
                url:
                    `${lambda}/cancelSubscription?appname=${appname}&clientid=${userData?.clientid}&effect=true`,
                headers: {
                    Authorization: `Bearer ${token}`, // Optional: Add this if needed
                },
            });

            if (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);
                    return;
                }

                try {
                    // Sign out the user
                    await tmdbApi.SignOutClient(
                        { emailId: userData.emailId },
                        "mmmmmmmmmm"
                    );
                } catch (error) {
                    console.error("Sign-out error:", error);
                }

                navigate("/signin");
                setShowPopup(false);
            }
        } catch (error) {
            console.error("Cancellation error:", error);
        } finally {
            setLoaderEnable("");
        }
    };

    const handleValidation = (evnt) => {
        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        //for password 
        if (passwordInputFieldName === 'password' || passwordInputFieldName === 'oldPassword') {
            const uppercaseRegExp = /(?=.*?[A-Z])/;
            const lowercaseRegExp = /(?=.*?[a-z])/;
            const digitsRegExp = /(?=.*?[0-9])/;
            const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
            const minLengthRegExp = /.{8,}/;
            const passwordLength = passwordInputValue.length;
            const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
            const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
            const digitsPassword = digitsRegExp.test(passwordInputValue);
            const specialCharPassword = specialCharRegExp.test(passwordInputValue);
            const minLengthPassword = minLengthRegExp.test(passwordInputValue);
            let errMsg = "";
            if (passwordLength === 0) {
                errMsg = "Password is empty";
            }

            if (uppercasePassword) {
                var element = document.getElementById("err1");
                element?.classList?.add("vaild");
                setUpper(true);
            } else {
                var element = document.getElementById("err1");
                element?.classList?.remove("vaild");
                setUpper(false);
            }
            if (lowercasePassword) {
                var element = document.getElementById("err");
                element?.classList?.add("vaild");
                setLower(true);
            } else {
                var element = document.getElementById("err");
                element?.classList?.remove("vaild");
                setLower(false);
            }
            if (digitsPassword) {
                var element = document.getElementById("err2");
                element?.classList?.add("vaild");
                setNumber(true);
            } else {
                var element = document.getElementById("err2");
                element?.classList?.remove("vaild");
                setNumber(false);
            }
            if (specialCharPassword) {
                var element = document.getElementById("err3");
                element?.classList?.add("vaild");
                setSpecial(true)
            } else {
                var element = document.getElementById("err3");
                element?.classList?.remove("vaild");
                setSpecial(false)
            }
            if (minLengthPassword) {
                var element = document.getElementById("err4");
                element?.classList?.add("vaild");
                setLimit(true)
            } else {
                var element = document.getElementById("err4");
                element?.classList?.remove("vaild");
                setLimit(false)
            }

            if (limit && upper && special && lower && number && confirmPasswordError === "") {
                setError("")
            }
            setPasswordErr(errMsg);
        }


    }
    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state

        setProfileData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));

    };
    // console.log("formDataaaaaaa",formData)
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "contactname") {
            setProfileData(prev => ({
                ...prev,
                [name]: value
            }));
        }
        else if (name === "idc") {
            setProfileData(prev => ({
                ...prev,
                [name]: value
            }));
        }
        else if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = profileData?.idc?.trim(); // Directly get the latest idc value

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
            else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            setProfileData(prev => ({ ...prev, [name]: formattedValue }));
        }
    };

    const handleAddclass = (evnt) => {
        let element = document.getElementById("instruction");
        element?.classList?.add("ins-dsp-none");
        setConfirmPasswordError("");
    }
    const handleRemoveclass = (evnt) => {
        let element = document.getElementById("instruction");
        element?.classList?.remove("ins-dsp-none");
    }
    const handleConfirm = (evnt) => {
        const passwordInputFieldName = evnt.target.name;
        if (passwordInputFieldName === "confirmPassword" || (passwordInputFieldName === "password")) {

        }
    }

    const RemoveError = () => {
        setOldPasswordError("");
    }

    console.log("passwordInput", passwordInput);

    useEffect(() => {
        myArray = localStorage.getItem("ClientName")?.split(" ");


    }, [localStorage.getItem("ClientName")]);

    let myArray = []
    myArray = localStorage.getItem("ClientName")?.split(" ");

    let k = countries && countries?.length > 0 && countries?.filter(eachItem => eachItem.alpha2 === defaultCountryCode)
    return (
        <>


            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="main-content edit-content user-management profile" id="user-profile-section">

                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="profile-title">Profile</h4>

                                        </div>
                                        <div>
                                            <a onClick={handleBack} onKeyDown={keyActivate(handleBack)} className="stroke-btn-style"><span className="material-symbols-outlined" id="profile-backbutton">arrow_back</span>Back</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Profile is the other page clients open looking for their account
                                settings, so the state of their bank account belongs here too -
                                a reminder while it's unfinished, a short confirmation once it
                                isn't. Either way it links through to Business Profile, where
                                the account details live and can be updated. */}
                            <div className="row" id="profile-bank-connect-row">
                                <BankConnectBanner showWhenConnected />
                            </div>
                            <div className="create-user-block" id="create-user-block">
                                <div className="form-block" id="form-block">
                                    <div className="row">
                                        <div className="col-md-7 user-details" id="user-details">
                                            <h3 id="user-details-title">User Details</h3>
                                            <div className="mb-3 row" id="name-row">
                                                <div className="col-md-12">
                                                    <label for="name-input" className="col-form-label">NAME</label>
                                                    <input className="form-control" placeholder="Enter Name" type="text" name="contactname" value={profileData?.contactname} onChange={handleChange} id="profile-name-input" />
                                                </div>
                                                {nameerror ? <span className="errormsg" id="profile-name-error" style={{ fontWeight: 'bold', color: 'red' }}>{nameerror}</span> : ""}
                                            </div>
                                            <div className="mb-3 row" id="email-row">
                                                <div className="col-md-12">
                                                    <label for="email-input" className="col-form-label">E MAIL ID</label>
                                                    <input className="form-control contact-number" type="email" value={profileData?.emailId} placeholder="Enter Company Email" id="profile-email-input" disabled />
                                                </div>
                                            </div>
                                            <div className="mb-3 row" id="phone-number-row">
                                                <div className="col-md-12">
                                                    <label for="phone-input" className="col-form-label">PHONE NUMBER</label>
                                                    <div className="country-code" id="profile-country-code-block">
                                                        <select name="idc" value={profileData?.idc} className="colorselect capitalize" onChange={handleCountryChange} id="profile-country-code-select">
                                                            <option value="">Select</option>
                                                            {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                                return (
                                                                    <><option key={i} value={task.alpha3}>{task.alpha3}{task.countrycode}</option></>
                                                                )
                                                            }
                                                            )}
                                                        </select>
                                                        <input className="form-control contact-number" type="tel" value={profileData?.phone} name="phone" onChange={handleChange} placeholder="Phone number" id="profile-phone-input" />
                                                    </div>
                                                    <span className="errormsg" id="profile-country-code-error" style={{ fontWeight: 'bold', color: 'red' }}>{IdcError}</span>
                                                    {phoneerror ? <span className="errormsg" id="profile-phone-error" style={{ fontWeight: 'bold', color: 'red' }}>{phoneerror}</span> : ""}
                                                </div>
                                            </div>


                                            <div className="mb-3 row" id="profile-update-button-row">
                                                <div className="col-md-12">
                                                    <button onClick={handleUserUpdate} className={`${!isUpdated ? "fill-btn-style disable" : "fill-btn-style"}`} id="update-button" disabled={!isUpdated || loaderEnable === "updateForm"}>
                                                        {loaderEnable === "updateForm" ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />) : null}
                                                        UPDATE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-5 prfile-block" id="profile-block">
                                            <div className="avatar-block" id="profile-avatar-block">
                                                <div className="avatar-header" id="profile-avatar-header">
                                                    <div className="avatar-img-block" id="profile-avatar-img-block">
                                                        <p id="profile-avatar-initials">


                                                            {userName?.length > 1
                                                                ? (
                                                                    (userName[0]?.charAt(0) || "").toUpperCase() +
                                                                    (userName[1]?.charAt(0) || "").toUpperCase()
                                                                )
                                                                : (
                                                                    (userData?.contactname?.slice(0, 2) || "").toUpperCase()
                                                                )
                                                            }
                                                        </p>

                                                    </div>
                                                </div>
                                                <div className="avatar-body" id="profile-avatar-body">
                                                    <h6 className="username mt-3" id="profile-username">{userData?.contactname}</h6>
                                                    <p className="lg-badge badge" id="profile-user-type">{userData?.type}</p>
                                                </div>
                                                {userData?.usertype === "BRAND MANAGER" &&
                                                    <div className="text-center">

                                                        <h6>{businessData?.subscription}</h6>


                                                        <div className="d-flex justify-content-center gap-2 mb-3">
                                                            {businessData?.subscription !== "Premium Plan" && (
                                                                <button className="fill-btn-style" id="profile-update-button" onClick={handleUpgrade}>
                                                                    UPGRADE
                                                                </button>
                                                            )}

                                                            {(businessData?.subscriptionPrice !== "0" && businessData?.subscriptionPrice !== 0) && (
                                                                <button className="stroke-btn-style" id="profile-cancel-button" onClick={handleCancelSub}>
                                                                    CANCEL
                                                                </button>
                                                            )}
                                                        </div>

                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="create-user-block create-pwd-block" id="password-change-section">
                                <div className="form-block" id="profile-password-change-form">
                                    <h3 id="profile-password-change-title">Change Password</h3>
                                    <div className="row">
                                        <div className="col-md-7">
                                            <div className="mb-3 row form-wrapper">
                                                <div className="col-md-12 mb-3">
                                                    <label className="floatingInput">Old Password<span>*</span></label>
                                                    <input type={passwordShown ? "text" : "password"} value={passwordInput?.oldPassword} onChange={(e) => handlePasswordChange(e)} name="oldPassword" placeholder="Old Password" className="form-control" onFocus={RemoveError}
                                                        id="profile-old-password-input"
                                                    />
                                                    <p className="text-danger" id="profile-old-password-error">{oldPasswordError}</p>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <label className="floatingInput">New Password<span>*</span></label>
                                                    <input type={passwordShown ? "text" : "password"} value={passwordInput?.password} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleValidation} name="password" placeholder="Password" className="form-control" onBlur={(e) => { handleAddclass(e) }}
                                                        onFocus={(e) => { handleRemoveclass(e) }}
                                                        id="profile-new-password-input"
                                                    />
                                                    <p className="text-danger" id="profile-new-password-error">{passwordError}</p>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <label className="floatingInput">Confirm Password<span>*</span></label>
                                                    <input type={passwordShown ? "text" : "password"} value={passwordInput?.confirmPassword} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleConfirm} onBlur={(e) => { handleAddclass(e) }} onFocus={(e) => { handleRemoveclass(e) }} name="confirmPassword" placeholder="Password" className="form-control" id="confirm-password-input" />
                                                    <p className="text-danger" id="profile-confirm-password-error">{confirmPasswordError}</p>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="flex-left terms-block"> <input type="checkbox" id="profile-terms-check" onChange={(e) => togglePassword(e)} /><label>Show Password</label></div>
                                                </div>
                                                <p className="text-danger" id="profile-password-general-error">{error}</p>
                                                <div className="col-md-12">
                                                    <button className="fill-btn-style" id="profile-update-password-btn" onClick={e => handlePwdGenerate(e)} disabled={loaderEnable === "pwdGenerate"}>{loaderEnable === "pwdGenerate" ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />) : null}UPDATE</button>
                                                </div>
                                                <div className="create-password-instruction ins-dsp-none" id="profile-instruction">
                                                    <p className="error" id="profile-err">{lower ? <span className="material-symbols-outlined">
                                                        check
                                                    </span> : <span className="material-symbols-outlined">
                                                        close
                                                    </span>} Password must contain a lower case letter</p>
                                                    <p className="error" id="profile-err1"> {upper ? <span className="material-symbols-outlined">
                                                        check
                                                    </span> : <span className="material-symbols-outlined">
                                                        close
                                                    </span>} Password must contain an upper case letter</p>
                                                    <p className="error" id="profile-err2">  {number ? <span className="material-symbols-outlined">
                                                        check
                                                    </span> : <span className="material-symbols-outlined">
                                                        close
                                                    </span>} Password must contain a number</p>
                                                    <p className="error" id="profile-err3"> {special ? <span className="material-symbols-outlined">
                                                        check
                                                    </span> : <span className="material-symbols-outlined">
                                                        close
                                                    </span>} Password must contain a special character or a space</p>
                                                    <p className="error" id="profile-err4"> {limit ? <span className="material-symbols-outlined">
                                                        check
                                                    </span> : <span className="material-symbols-outlined">
                                                        close
                                                    </span>} Password must contain at least 8 characters</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                </div>
                            </div>
                            {/* Add this new section after the password change section and before the closing container-fluid div */}

                        
                            {/* Contact Us Section */}
                            {/* <div className="create-user-block contact-us-section" id="contact-us-section">
                                <div className="form-block" id="contact-us-form-block">
                                    <div className="row justify-content-center">
                                        <div className="col-md-8 col-lg-7">
                                            <h3 id="contact-us-title" className="text-center mb-2">Contact Support</h3>
                                            <p className="text-muted mb-4 text-center" style={{ fontSize: '14px' }}>
                                                We're here to help! Let us know what you need assistance with.
                                            </p>

                                            
                                            <div className="mb-4" style={{
                                                background: '#f0f4ff',
                                                padding: '20px',
                                                borderRadius: '12px',
                                                border: '1px solid #d0e0ff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '15px'
                                            }}>
                                                <div style={{
                                                    width: '48px',
                                                    height: '48px',
                                                    background: '#667eea',
                                                    borderRadius: '12px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0
                                                }}>
                                                    <span className="material-symbols-outlined" style={{ color: 'white', fontSize: '28px' }}>
                                                        mail
                                                    </span>
                                                </div>
                                                <div>
                                                    <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#6c757d', fontWeight: '500' }}>
                                                        Email Support
                                                    </p>
                                                    <p style={{ margin: 0, fontSize: '16px', color: '#667eea', fontWeight: '600' }}>
                                                        support@myspotsaver.com
                                                    </p>
                                                </div>
                                            </div>

                                            <form onSubmit={handleContactFormSubmit} id="contact-form">
                                               
                                                <div className="mb-4">
                                                    <label className="col-form-label" style={{ fontWeight: '600', fontSize: '15px', marginBottom: '12px' }}>
                                                        Issue Type <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="issue-type-buttons" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                                                        {['Bug Report', 'Feature Request', 'Booking Issue', 'Payment Problem', 'Account Issue', 'General Question', 'Other'].map((type) => (
                                                            <button
                                                                key={type}
                                                                type="button"
                                                                onClick={() => {
                                                                    setContactFormData(prev => ({ ...prev, issueType: type }));
                                                                    setContactFormErrors(prev => ({ ...prev, issueType: '' }));
                                                                }}
                                                                style={{
                                                                    padding: '10px 20px',
                                                                    borderRadius: '25px',
                                                                    border: contactFormData.issueType === type ? '2px solid #667eea' : '2px solid #e0e0e0',
                                                                    background: contactFormData.issueType === type ? '#f0f4ff' : 'white',
                                                                    color: contactFormData.issueType === type ? '#667eea' : '#6c757d',
                                                                    fontSize: '14px',
                                                                    fontWeight: contactFormData.issueType === type ? '600' : '500',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                                className="issue-type-btn"
                                                            >
                                                                {type}
                                                            </button>
                                                        ))}
                                                    </div>
                                                    {contactFormErrors.issueType && (
                                                        <span className="errormsg" style={{ fontWeight: 'bold', color: 'red', fontSize: '12px', display: 'block', marginTop: '8px' }}>
                                                            {contactFormErrors.issueType}
                                                        </span>
                                                    )}
                                                </div>

                                              
                                                <div className="mb-3">
                                                    <label className="col-form-label" style={{ fontWeight: '600', fontSize: '15px' }}>
                                                        Subject <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="subject"
                                                        value={contactFormData.subject}
                                                        onChange={handleContactFormChange}
                                                        className="form-control"
                                                        placeholder="Brief summary of your issue"
                                                        id="contact-subject-input"
                                                        style={{
                                                            padding: '12px 16px',
                                                            fontSize: '14px',
                                                            borderRadius: '8px',
                                                            border: '1px solid #e0e0e0'
                                                        }}
                                                    />
                                                    {contactFormErrors.subject && (
                                                        <span className="errormsg" style={{ fontWeight: 'bold', color: 'red', fontSize: '12px', display: 'block', marginTop: '5px' }}>
                                                            {contactFormErrors.subject}
                                                        </span>
                                                    )}
                                                </div>

                                              
                                                <div className="mb-4">
                                                    <label className="col-form-label" style={{ fontWeight: '600', fontSize: '15px' }}>
                                                        Message <span className="text-danger">*</span>
                                                    </label>
                                                    <textarea
                                                        name="message"
                                                        value={contactFormData.message}
                                                        onChange={handleContactFormChange}
                                                        className="form-control"
                                                        placeholder="Please describe your issue in detail..."
                                                        rows="6"
                                                        id="contact-message-input"
                                                        style={{
                                                            resize: 'vertical',
                                                            minHeight: '150px',
                                                            padding: '12px 16px',
                                                            fontSize: '14px',
                                                            borderRadius: '8px',
                                                            border: '1px solid #e0e0e0'
                                                        }}
                                                    ></textarea>
                                                    {contactFormErrors.message && (
                                                        <span className="errormsg" style={{ fontWeight: 'bold', color: 'red', fontSize: '12px', display: 'block', marginTop: '5px' }}>
                                                            {contactFormErrors.message}
                                                        </span>
                                                    )}
                                                </div>

                                               
                                                <div className="mb-3">
                                                    <button
                                                        type="submit"
                                                        className="fill-btn-style w-100"
                                                        id="contact-submit-btn"
                                                        disabled={isSubmittingContact || loaderEnable === "contactForm"}
                                                        style={{
                                                            padding: '14px',
                                                            fontSize: '15px',
                                                            fontWeight: '600',
                                                            borderRadius: '8px'
                                                        }}
                                                    >
                                                        {loaderEnable === "contactForm" ? (
                                                            <img
                                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                className="loading-icon"
                                                                alt="Loading"
                                                            />
                                                        ) : null}
                                                        SEND MESSAGE
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div> */}


                        </div>
                    </div>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="Ok"
                        confirmBtnBsStyle="primary"
                        title={"Updated successfully"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>
                    <Modal className="new-set-modal" show={popup} id="profile-modal">
                        <div className="modal-dialog modal-dialog-centered" id="profile-modal-dialog">
                            <div className="modal-content rounded-4" id="profile-modal-content">

                                {/* Modal Header */}
                                <div className="modal-header border-0 justify-content-center position-relative" id="profile-modal-header">
                                    <button className="close-btn" onClick={e => handleClose()} id="profile-close-btn">
                                        <span className="material-icons">close</span>
                                    </button>
                                </div>

                                {/* Modal Body */}
                                <div className="modal-body text-center" id="profile-modal-body">
                                    <img
                                        src={`${image}${appname}/images/web/disco-ball.gif`}
                                        alt="Delete Icon"
                                        className=""
                                        style={{ width: "100px", height: "100px" }}
                                        id="profile-modal-image"
                                    />

                                    <h3 className="modal-sm-heading" id="profile-modal-heading">Cancel Subscription</h3>
                                    <p className="modal-text" id="profile-modal-text">
                                        The changes cannot be undone.<br />
                                        Do you want to cancel subscription?
                                    </p>
                                </div>

                                {/* Modal Footer */}
                                <div className="modal-footer border-0 justify-content-center gap-3 pb-4" id="profile-modal-footer">
                                    <button className="stroke-btn-style" onClick={() => setShowPopup(false)} id="profile-btn-no">
                                        No
                                    </button>

                                    <button className="fill-btn save_continue" onClick={handleCancelling} id="profile-btn-yes">
                                        {loaderEnable === "cancel" ? (
                                            <img
                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                className="loading-icon"
                                                id="profile-loading-icon"
                                            />
                                        ) : null}
                                        Yes
                                    </button>
                                </div>

                            </div>
                        </div>
                    </Modal>


                    <Footer />
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover={false}
                        theme="light"
                        id="toastContainer"
                    />
                </div>
            </div>




        </>
    );
};

export default Profile;
